import { Website } from '@/models/website'

export class TenantUser{
  id?: string;
  companyId?: string;
  name?: string;
  mail?: string;
  websites?: Array<Website>;

  constructor(params?: Partial<TenantUser>) {
    Object.assign(this, params);
  }
}